
























import { Component, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { NAV_LOADING_END, NAV_LOADING_START } from '@/config/event'
import {
  AlertMessage,
  ChildCollection,
  collectionApi,
  ErrorMessage
} from '@/api'
import { ChildCollectionListTable } from '@/components/organisms/ChildCollectionListTable'

interface ModalChildCollectionListInterface {
  collectionId: number
  onClickTitle: (
    bibliographyId: number,
    collectionNo: string,
    title: string
  ) => void
}

@Component({
  components: {
    ChildCollectionListTable,
    ModalFooter
  }
})
export default class ModalChildCollectionList extends ComponentVue {
  @Ref()
  childCollectionListTable!: ChildCollectionListTable

  dialog: boolean = false

  tableBodyHeight: number = 0

  titleCallback?: (
    bibliographyId: number,
    collectionNo: string,
    title: string
  ) => void

  tableItems: ChildCollection[] = []

  open(params: ModalChildCollectionListInterface): void {
    this.dialog = true
    this.titleCallback = params.onClickTitle
    this.getChildCollections(params.collectionId)
    window.addEventListener('resize', this.calculateTableHeight)
    this.$nextTick(this.calculateTableHeight)
  }

  close(): void {
    this.dialog = false
    this.titleCallback = undefined
    this.tableItems = []
    this.childCollectionListTable.initializeSort()
    window.removeEventListener('resize', this.calculateTableHeight)
  }

  calculateTableHeight() {
    this.tableBodyHeight = 0

    this.$nextTick(() => {
      const modalElements: HTMLCollection | null = document.getElementsByClassName(
        'v-dialog--active'
      ) as HTMLCollectionOf<HTMLElement>

      this.tableBodyHeight =
        window.innerHeight -
        (modalElements[modalElements.length - 1]?.clientHeight + 48)
    })
  }

  onClickTitle(obj: {
    bibliographyId: number
    collectionNo: string
    title: string
  }): void {
    if (this.titleCallback) {
      this.titleCallback(obj.bibliographyId, obj.collectionNo, obj.title)
    }

    this.close()
  }

  print() {
    const element = document.querySelector('#modal-child-collection-list')

    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }

  async getChildCollections(collectionId: number): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      this.tableItems = await collectionApi.getChildCollections({
        collectionId
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }

      this.close()
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }
}
